import React from 'react';
import CRMBoard from '../../components/admin-dashboard/crm/CRMBoard';

const CourseCRM = () => {
  return <CRMBoard pipelineType="course" />;
};

export default CourseCRM;
